import { useContext } from 'react'
import { HubspotConversationsContext } from './hubspot-conversations-context'

export function useHubspotConversations() {
  const context = useContext(HubspotConversationsContext)

  if (context === null) {
    throw new Error('useHubspotConversations must be used within HubspotConversationsProvider')
  }

  return context
}
